import React from 'react';
import { Link } from 'react-router-dom';
import { m } from 'framer-motion';
import { Helmet } from 'react-helmet-async';
import Footer from '../Footer/Footer';
import { formatDate } from 'utils/date';

import useNewsPosts from 'hooks/useNewsPosts';

import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/opacity.css';

export default function News() {
  const { isLoading, newsPosts, featuredNews } = useNewsPosts();

  if (isLoading) {
    return null;
  }

  return (
    <m.main
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className="news"
    >
      <Helmet>
        <title>News - DuskBreakers</title>
        <meta name="description" content="Latest news from the DuskBreakers project." />
      </Helmet>

      <section
        className="
        d-flex
        align-items-center
        justify-content-center
      "
      >
        <div className="container">
          <div className="row">
            <div className="col">
              <h1 className="mb-5">News</h1>
              <div className="pb-4">
                <div className="card linkcard h-100 m-0">
                  {featuredNews && (
                    <Link
                      className="featured-post posts__post noline stretched-link"
                      to={`/news/${featuredNews.id}/${featuredNews.slug}`}
                    >
                      <LazyLoadImage
                        className="img-fluid w-100"
                        alt={featuredNews.title}
                        src={featuredNews.imageUrl}
                        effect="opacity"
                      />
                      <div className="card-body">
                        <div className="text-small text-muted mb-2">
                          <span>{formatDate(featuredNews.publishDate)}</span>
                        </div>
                        {featuredNews.title}
                      </div>
                    </Link>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="mt-n6 mt-lg-n7">
        <div className="container">
          <div className="row d-flex justify-content-center">
            <div className="col">
              <div className="posts__container">
                <div className="row d-flex g-4">
                  {newsPosts.map(({ id, slug, imageUrl, title, publishDate }) => {
                    return (
                      <div key={id} className="col-md-4">
                        <div className="card linkcard h-100 m-0">
                          <Link
                            className="posts__post noline stretched-link"
                            to={`/news/${id}/${slug}`}
                          >
                            <LazyLoadImage
                              className="img-fluid w-100"
                              alt={title}
                              src={imageUrl}
                              effect="opacity"
                            />

                            <div className="card-body">
                              <div className="text-small text-muted mb-2">
                                <span>{formatDate(publishDate)}</span>
                              </div>
                              {title}
                            </div>
                          </Link>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </m.main>
  );
}
